import { render, staticRenderFns } from "./LoadConsigneeModal.vue?vue&type=template&id=73b9bb42&scoped=true"
import script from "./LoadConsigneeModal.vue?vue&type=script&lang=js"
export * from "./LoadConsigneeModal.vue?vue&type=script&lang=js"
import style0 from "./LoadConsigneeModal.vue?vue&type=style&index=0&id=73b9bb42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9bb42",
  null
  
)

export default component.exports